import React from 'react';
import {
  Container,
  Stack,
  Divider,
  Box,
  Button,
  FormControl,
  Paper,
  Grid,
  Typography
} from '@mui/material';
import {
  Autocomplete,
  Datas,
  AprovacoesCheckbox
} from '../../../components';
import api from '../../../services/api';
import * as yup from 'yup';
import { useStoreState, useStoreActions, reducer } from 'easy-peasy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import DadosGerais from './DadosGerais';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CSVDownload } from 'react-csv';
import { tagsRel, tagsRelAreas } from './static';
import { estados } from './estadosBrasileiros';
import { removerQuebrasDeLinha } from '../../../utils/removerQuebraDeLinha';

const Tema04 = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let user = useStoreState(state => state.auth.user);

  const [empresas, setEmpresas] = React.useState([]);
  const [ano, setAno] = React.useState(new Date().getFullYear() - 1);
  const [csvDataAreas, setCsvDataAreas] = React.useState([]);
  const [csvData, setCsvData] = React.useState([]);

  const schema = yup
    .object({
      empresaId: yup.number().nullable().label('Selecione a empresa').required()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    watch,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const watchEmpresaId = watch('empresaId');

  const onChangeAno = (event, ano) => {
    setAno(ano);
  };

  const loadEmpresas = async mount => {
    startLoading();
    if (mount.isMounted)
      try {
        let matrizes = (
          await api.http.get(
            '/empresas/' +
              (user.roleId == 'admin' ? '?all=1&matriz=1' : '?matriz=1')
          )
        ).data;
        setEmpresas(matrizes);
        stopLoading();
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
  };
  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  function extrairDataHora(dateTimeStr) {
    const dateObj = new Date(dateTimeStr);
    const year = dateObj.getFullYear().toString();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const date = `${day}-${month}-${year}`;
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    return date + ' ' + time;
  }
  function converterParaReal(valor) {
    const valorFormatado = valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
    return valorFormatado;
  }
  const opcoesBooleanas = [
    {
      id: 1,
      label: 'SIM'
    },
    {
      id: 2,
      label: 'NÃO'
    }
  ];
  const exportDadosAreas = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/04/areas-protegidas-e-impactadas'))
        .data;
      const dadosCsvAreas = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa?.nome),
          ano: data?.ano,
          unidadeFederativa: data?.unidadeFederativa
            ? estados[data.unidadeFederativa - 1].label
            : null,
          areasProtegidas: data?.areasProtegidas,
          areasImpactadas: data?.areasImpactadas,
          fonteDaInformacao: data?.fonteDaInformacao,
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsvAreas.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvDataAreas([tagsRelAreas, ...dadosCsvAreas]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  const exportDadosGerais = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/04/mitigacao-impactos-ambientais')).data;    
        const dadosCsv = dados.map((data)=>{
          return{
            cnpj:data?.empresa?.cnpj,
            empresa:removerQuebrasDeLinha(data?.empresa?.nome),
            ano:data?.ano,
            areaDoacaoEstadoHa:data?.areaDoacaoEstadoHa,
            valorTaxaCompensacaoReal:data?.valorTaxaCompensacaoReal?converterParaReal(data.valorTaxaCompensacaoReal):null,
            valorInvestidoTerceirosReal:data?.valorInvestidoTerceirosReal?converterParaReal(data.valorInvestidoTerceirosReal):null,
            valorInvestidoConvenioReal:data?.valorInvestidoConvenioReal?converterParaReal(data.valorInvestidoConvenioReal):null,
            areaConvenioHa:data?.areaConvenioHa,
            possuiInventarioEmissao:data?.possuiInventarioEmissao?opcoesBooleanas[data.possuiInventarioEmissao-1].label:null,
            inventarioEscopoUm:data?.inventarioEscopoUm,
            inventarioEscopoDois:data?.inventarioEscopoDois,
            observacoes:removerQuebrasDeLinha(data?.observacoes),
            numeroDeMinas:data?.numeroDeMinas,
            numeroPlanosFechamento:data?.numeroPlanosFechamento,
            indicadorFechamentoAvaliado:data?.indicadorFechamentoAvaliado,
            indicadorFechamentoAaa:data?.indicadorFechamentoAaa,
            indicadorFechamentoAa:data?.indicadorFechamentoAa,
            indicadorFechamentoA:data?.indicadorFechamentoA,
            indicadorFechamentoB:data?.indicadorFechamentoB,
            indicadorFechamentoC:data?.indicadorFechamentoC,
            indicadorFechamentoObservacao:data?.indicadorFechamentoObservacao,
            indicadorSustentabilidadeAvaliado:data?.indicadorSustentabilidadeAvaliado,
            indicadorSustentabilidadeAaa:data?.indicadorSustentabilidadeAaa,
            indicadorSustentabilidadeAa:data?.indicadorSustentabilidadeAa,
            indicadorSustentabilidadeA:data?.indicadorSustentabilidadeA,
            indicadorSustentabilidadeB:data?.indicadorSustentabilidadeB,
            indicadorSustentabilidadeC:data?.indicadorSustentabilidadeC,
            indicadorSustentabilidadeObservacao:data?.indicadorSustentabilidadeObservacao,
            colaboracaoAmbientalMesmoTerritorio:data?.colaboracaoAmbientalMesmoTerritorio?'SIM':'NÃO',
            planoDeAcaoConjunto:data?.planoDeAcaoConjunto?'SIM':'NÃO',
            melhoriaDoProcesso:data?.melhoriaDoProcesso?'SIM':'NÃO',
            qualificacaoDosEstudos:data?.qualificacaoDosEstudos?'SIM':'NÃO',
            melhoriaDasAvaliacoes:data?.melhoriaDasAvaliacoes?'SIM':'NÃO',
            planejamentoDoProcesso:data?.planejamentoDoProcesso?'SIM':'NÃO',
            validacaoDoDesempenho:data?.validacaoDoDesempenho?'SIM':'NÃO',
            adocaoDeMedidas:data?.adocaoDeMedidas?'SIM':'NÃO',
            integracaoDoConceito:data?.integracaoDoConceito?'SIM':'NÃO',
            adocaoDasMelhoresPraticas:data?.adocaoDasMelhoresPraticas?'SIM':'NÃO',
            observacoesFinais:removerQuebrasDeLinha(data?.observacoesFinais),
            createdAt:data.createdAt?extrairDataHora(data.createdAt):null,
            updatedAt:data.updatedAt?extrairDataHora(data.updatedAt):null
        }
      });
      if(dadosCsv.length === 0){
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvData([tagsRel, ...dadosCsv]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    <Container>
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Dados básicos</h3>
        </Divider>
        <Box component="form" autoComplete="off">
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <Autocomplete
                field="empresaId"
                useFormRef={useFormRef}
                options={empresas}
                getOptionLabel={empresa =>
                  empresa.nome + ' (' + empresa.cnpj + ')'
                }
                schema={schema}
              />
            </FormControl>
            <Datas onChange={onChangeAno} value={ano} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <AprovacoesCheckbox />
          </Stack>
          {['admin', 'gestor', 'preenchedorSso'].includes(user.roleId) && (
            <Stack direction="row" spacing={2} mt={2}>
              <Button
                variant="contained"
                onClick={exportDadosGerais}
                sx={{ height: 45 }}
              >
                <FileDownloadIcon /> Exportar Dados Gerais (CSV)
              </Button>
              {csvData && csvData.length > 0 && (
                <CSVDownload
                  data={csvData}
                  headers={tagsRel.headers}
                  separator=";"
                  target="_blank"
                />
              )}

              <Button
                variant="contained"
                onClick={exportDadosAreas}
                sx={{ height: 45 }}
              >
                <FileDownloadIcon /> Exportar Dados Áreas Protegidas/Impactadas
                (CSV)
              </Button>
              {csvDataAreas && csvDataAreas.length > 0 && (
                <CSVDownload
                  data={csvDataAreas}
                  headers={tagsRelAreas.headers}
                  separator=";"
                  target="_blank"
                />
              )}
            </Stack>
          )}
        </Box>
      </Paper>

      {watchEmpresaId && (
        <>
          <Paper
            variant="outlined"
            className="center-box"
            sx={{
              textAlign: 'center',
              px: 4,
              pt: 2,
              pb: 3,
              m: 5
            }}
          >
            <DadosGerais ano={ano} watchEmpresaId={watchEmpresaId} />
          </Paper>
        </>
      )}
    </Container>
  );
};

export default Tema04;
